import { AddressErrors } from 'hooks/useDeliveryValidation';

export const onClosePath = (redirectPath: string) : string => {
   return redirectPath?.includes('address') ? '../../address' : redirectPath;
};

export const getRedirectPathForDeliveryError = (redirectPath: string, errorType: string) => {
   if (errorType === AddressErrors.ADDRESS_NOT_FOUND) {
      return `${redirectPath}`;
   }

   return errorType === AddressErrors.ADDRESS_NOT_VALID ? `${redirectPath}-error`: redirectPath;
};
